<template>
  <f7-page
    ptr
    @ptr:refresh="refreshData"
    @page:reinit="getList"
    infinite
    :infinite-distance="50"
    :infinite-preloader="showPreloader"
    @infinite="loadMore">
    <f7-navbar :no-shadow="true">
      <f7-nav-left
        color-theme="white"
        back-link="返回"
        back-link-url="/bid/list">
      </f7-nav-left>
      <f7-nav-title>排行榜</f7-nav-title>
    </f7-navbar>
    <div style="padding: 0.5rem 0rem;">
      <div style="text-align: center; padding: 0.5rem 0.5rem;" v-if="teamList.length === 0">
        暂无队伍信息
      </div>
      <div v-else>
        <div class="has-content"></div>
        <div v-for="(item, index) in teamList" :key="item.id">
          <div class="has-content" style="padding-top: 0rem; padding-bottom: 0rem;">
            <bid-team :team="item"></bid-team>
          </div>
          <div class="divider-row" v-if="index !== teamList.length - 1"></div>
        </div>
      </div>
    </div>
  </f7-page>
</template>
<script>
import { getBidTopTeam } from '@/api/bid';
import BidTeam from '@/components/BidTeam';

export default {
  components: {
    BidTeam,
  },
  data() {
    return {
      teamList: [],
      pageObj: { page: 1, pageSize: 10 },
      allowInfinite: true,
      showPreloader: true,
    };
  },
  created() {
    this.getList();
  },
  methods: {
    refreshData(event, done) {
      Promise.all([this.getList()]).then(() => done());
    },
    getList(pageParam) {
      this.pageObj = pageParam || { page: 1, pageSize: 10 };
      getBidTopTeam(this.pageObj).then((result) => {
        if (result.code === 0) {
          if (this.pageObj.page === 1) {
            this.teamList = result.data || [];
          } else {
            (result.data || []).forEach((item) => {
              const pos = this.teamList.findIndex(w => w.id === item.id);
              if (pos < 0) {
                this.teamList.push(item);
              } else {
                this.teamList.splice(pos, 1, item);
              }
            });
          }
          this.allowInfinite = true;
          if (this.teamList.length < 10 || (result.data || []).length === 0) {
            this.showPreloader = false;
            this.allowInfinite = false;
          }
        }
      });
    },
    loadMore() {
      if (!this.allowInfinite) {
        return;
      }
      this.allowInfinite = false;
      if (this.teamList.length >= 100) {
        this.showPreloader = false;
        return;
      }
      this.$set(this.pageObj, 'page', this.pageObj.page + 1);
      this.getList(this.pageObj);
    },
  },
};
</script>

<style lang="scss" scoped>
  @import '~@/style/app-var.scss';

  .divider-row {
    font-size: 0.5rem;
    height: 0.5rem;
    width: 100%;
  }

</style>



// WEBPACK FOOTER //
// src/pages/bid/topTeamList.vue